(() => {
  'use strict';
  const initialize = () => {
    document.querySelectorAll('[data-brew-studio]').forEach((studio) => {
      if (studio.dataset.brewReady) return;
      studio.dataset.brewReady = 'true';
      const tablist = studio.querySelector('[data-brew-tabs]');
      const tabs = [...studio.querySelectorAll('[data-brew-tab]')];
      const panels = [...studio.querySelectorAll('[data-brew-panel]')];
      if (!tablist || !tabs.length || !panels.length) return;
      const format = (value) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', { maximumFractionDigits: 1 }).format(value);
      const update = (panel) => {
        const input = panel.querySelector('[data-brew-input]');
        const dose = Number(input.value);
        const valid = input.value.trim() !== '' && Number.isFinite(dose) && dose >= Number(input.min) && dose <= Number(input.max) && input.validity.valid;
        const error = panel.querySelector('[data-brew-error]');
        error.hidden = valid;
        input.setAttribute('aria-invalid', String(!valid));
        const output = panel.querySelector('[data-brew-output]');
        const equivalent = panel.querySelector('[data-brew-equivalent]');
        if (!valid) { output.textContent = '—'; equivalent.textContent = ''; panel.querySelectorAll('[data-brew-dose],[data-brew-water],[data-brew-first]').forEach((element) => { element.textContent = '—'; }); return; }
        const isEspresso = panel.dataset.brewPanel === 'espresso';
        const useUS = panel.querySelector('[data-brew-units]')?.value === 'us';
        const water = dose * Number(panel.dataset.defaultWater) / Number(panel.dataset.defaultDose);
        const waterText = (value) => useUS ? `${format(value / 29.57353)} US fl oz` : `${format(value)} g`;
        const stepWaterText = (value) => useUS ? `${format(value)} g (≈ ${format(value / 29.57353)} US fl oz)` : `${format(value)} g`;
        output.textContent = isEspresso ? `${format(water)} g` : waterText(water);
        equivalent.textContent = isEspresso ? '' : useUS ? `≈ ${format(water)} mL · ${format(water)} g` : `≈ ${format(water)} mL · ${format(water / 29.57353)} US fl oz`;
        panel.querySelectorAll('[data-brew-dose]').forEach((element) => { element.textContent = format(dose); });
        panel.querySelectorAll('[data-brew-water]').forEach((element) => { element.textContent = isEspresso ? `${format(water)} g` : stepWaterText(water); });
        panel.querySelectorAll('[data-brew-first]').forEach((element) => { element.textContent = stepWaterText(dose * Number(panel.dataset.firstWater) / Number(panel.dataset.defaultDose)); });
      };
      panels.forEach((panel) => {
        const input = panel.querySelector('[data-brew-input]');
        input.addEventListener('input', () => update(panel));
        panel.querySelector('[data-brew-units]')?.addEventListener('change', () => update(panel));
        const reset = panel.querySelector('[data-brew-reset]');
        reset.hidden = false;
        reset.addEventListener('click', () => {
          input.value = panel.dataset.defaultDose;
          const units = panel.querySelector('[data-brew-units]');
          if (units) units.value = 'metric';
          update(panel);
          input.focus({ preventScroll: true });
        });
        const unitsControl = panel.querySelector('[data-brew-unit-control]');
        if (unitsControl) unitsControl.hidden = false;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', `brew-tab-${panel.dataset.brewPanel}`);
        update(panel);
      });
      const activate = (tab, moveFocus = false) => {
        tabs.forEach((item) => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel) => { panel.hidden = panel.dataset.brewPanel !== tab.dataset.brewTab; });
        if (moveFocus) tab.focus({ preventScroll: true });
      };
      tablist.setAttribute('role', 'tablist');
      tablist.hidden = false;
      tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          activate(tabs[next], true);
        });
      });
      activate(tabs[0]);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize); else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
